<!-- 
    参数格式

list        非必填          [{name:展示名称,type:跳转路由}]

bgColor     非必填          "#ff"  -   背景颜色

<slot name="logo-wrap">     插槽 控制logo 和 tab
<slot name="tab-wrap">

-->

<template>
  <div class="header">
    <div class="main">
      <div class="left">
        <div class="logo-wrap">
          <div>
            <img class="img" :src="$globalHeader.fileUrl+'/static/fjtwfw/logo_mini.png'" alt="logo" />
          </div>
          <div class="name-wrap">
            <div>福建通文产业服务有限公司</div>
            <div class="line-text">
              <span></span>
              <div>高质量就业服务提供商</div>
              <span></span>
            </div>
          </div>
        </div>
        <div class="navBlock">
          <div class="nav-list">
            <div class="nav-item" v-for="(item, index) in navList" :key="index" :class="{ 'active': currentIndex == index }">
              <div class="nav-content" @click="handleEnter(item, item.categoryCode)">
                {{ item.categoryName }}<i v-if="item.list" class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <ul class="submenu">
                <li v-for="(t, i) in item.list" :key="i" @click="handleEnter(t, item.categoryCode)" class="sub-item">
                  {{ t.categoryName }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <el-input v-model="searchKey" type="text" @change="searchChange" class="input" style="width: 260px;" suffix-icon="el-icon-search" placeholder="请输入关键字"></el-input>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getNavList } from "@/api/common/common";
export default {
  props: ["list", "currentIndex", "splitLine", "keyWord"],
  data() {
    return {
      searchKey: "", //搜索内容
      navList: [],

    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    chooseTab(item) {
      if (item.type == "home") {
        this.$router.push("/");
      } else {
        if (item.type && typeof item.type == "string") {
          //  this.$router.replace("/" + item.type);
          window.location.href = "/" + item.type;
        }
      }
    },
    searchChange() {
      if (!this.searchKey || this.searchKey == '') return
      //搜索结果页面
      this.$router.push({
        path: "/searchPage/searchResult",
        query: {
          keyWord: this.searchKey,
        },
      });
    },
    fetchData() {
      this.searchKey = this.word

      getNavList({ websiteType: 1 }).then((res) => {
        this.navList = res.data;
      });
    },
    handleEnter(item, tabcode) {
      if (item.list) {
        item = item.list[0];
      }
      this.currentCode = tabcode
      console.log(item.linkUrl);

      if (item.linkUrl == "home") {
        this.$router.push("/");
      } else {

        let baseUrl =
          "?categoryId=" +
          item.categoryCode +
          "&linkType=" +
          item.linkType +
          "&tabcode=" +
          tabcode +
          "&seccode=" +
          item.categoryCode;

        let url = "";
        if (item.linkType == '7') {
          window.open(item.linkUrl);
        } else {
          switch (item.linkType) {
            case "1":
              url = "/article" + baseUrl;
              break;
            case "2":
              url = "/singleImage" + baseUrl;
              break;
            case "3":
              url = "/imageText" + baseUrl;
              break;
            case "5":
              url = "/tabList" + baseUrl;
              break;
            case "8":
              url = "/coopPartner" + baseUrl;
              break;
            case "9":
              url = "/contactUs" + baseUrl;
              break;

            default:
              baseUrl;
          }
          url = item.linkUrl || item.url != null ? url + "&id=" + item.linkUrl : url

          window.location.href = url;
        }


      }
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 100000;
  width: 100%;

  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;

    .left {
      flex-shrink: 0;
      display: flex;
      align-items: center;

      .logo-wrap {
        padding: 0;
        margin: 0;
        line-height: 1;
        display: flex;
        align-items: center;
        margin-right: 80px;
        max-width: 400px;

        .img {
          width: 100%;
          height: 60px;
        }

        .name-wrap {
          display: flex;
          flex-direction: column;
          text-align: center;
          font-weight: bold;
          color: #4d4d4d;
          letter-spacing: 4px;
          margin-left: 10px;

          :nth-child(1) {
            font-size: 20px;
            margin-bottom: 6px;
          }
          .line-text {
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              width: 10%;
              height: 1px;
              background-color: #ccc; /* 可换成你想要的颜色 */
              margin: 0 10px;
            }

            div {
              white-space: nowrap;
              font-weight: bold;
              font-size: 10px; /* 可根据需要调整 */
            }
          }
        }

        .title {
          margin-left: 12px;
          font-size: 20px;
        }
      }

      .split-line {
        width: 1px;
        height: 40px;
        transform: translate(-20px, 0);
        background-color: #f1f1f1;
      }

      .navBlock {
        .nav-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .icon {
          margin-right: 0.2em;
        }

        .active {
          color: #2d7cce;
        }

        .active::after {
          content: "";
          position: absolute;
          left: 45%;
          bottom: 5px;
          transform: translate(-50%, 0);
          width: calc(100% - 50px);
          height: 3px;
          border-radius: 2px;
          background-color: #2d7cce;
          overflow: hidden;
        }

        .nav-item {
          cursor: pointer;
          min-width: 120px;
          color: #000;
          font-size: 17px;
          font-weight: 500;
          text-align: center;
          display: inline-block;
          position: relative;
          z-index: 99;
          .nav-content {
            height: 50px;
            line-height: 50px;
          }
        }
        .nav-content:hover,
        .sub-item:hover {
          color: #087cd6;
        }

        li {
          list-style: none;
          line-height: 50px;
          width: 120px;
        }
        .submenu {
          position: absolute;
          top: 50px;
          max-height: 0;
          overflow: hidden;
          background: #fff;
          width: 120px;
          margin: 0;
          padding: 0;
          text-align: center;
        }
        .nav-item:hover {
          .submenu {
            max-height: 400px;
            background: #fff;
            width: 120px;
            margin: 0;
            padding: 0;
          }
        }
      }
    }

    .right {
      flex-shrink: 0;
      position: relative;
      display: flex;
      align-items: center;
      margin: 10px 0;
      padding: 6px 12px;
      border: 1px solid #f2f2f2;
      cursor: pointer;
      border-radius: 3px;

      .img-wrap {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .r-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 12px;

        .title {
          font-size: 15px;
          font-weight: bold;
          color: #000;
        }

        .subtitle {
          font-size: 12px;
          color: #999;
        }
      }

      .right-box {
        border-radius: 3px 0 3px 3px;
        box-sizing: border-box;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        padding: 12px 24px;
        top: 52px;
        right: 0;
        background-color: #fff;
        border: 1px solid #f2f2f2;
        box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);
        z-index: 10;

        .img-wrap {
          width: 160px;
          height: 160px;
          overflow: hidden;
          border-radius: 0;
        }

        span {
          padding: 10px 0;
          font-size: 14px;
        }
      }
    }

    .right:hover {
      .right-box {
        display: flex;
      }
    }
  }
}
</style>